import { NAME as FUSE_NAME } from 'constants';

export const NAME = `${FUSE_NAME}/PREFERENCES`;
export const REDUCER_NAME = 'preferences';
